export default __webpack_public_path__ + "static/media/bbbaidja-color.687641f2.svg";